import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BadgeContainer } from "./styled";
import { FlexSpan } from "../Grid";
import { Icon } from "../Icon";
export const Badge = ({ children, ...props }) => {
    return (_jsxs(BadgeContainer, { ...props, children: [props.icon && (_jsx(FlexSpan, { display: "flex", mr: "0.25rem", children: _jsx(Icon, { icon: props.icon, color: props.iconColor, size: props.small ? 12 : undefined }) })), _jsx(FlexSpan, { children: children })] }));
};
